














































































































import Vue from 'vue';
import Api from '../../base/api.typings';
import Component from 'vue-class-component';
import routerService from '../../base/router-service';
import { Prop } from 'vue-property-decorator';
import pedidoService from './pedido-service';
import { obterDiaMesAnoFormatado } from '@/utils/utils';

@Component
export default class LicencaVisualizar extends Vue {
    @Prop() pedidoId: string;
    pedido: Api.App.Server.Pedido.ObterParaVisualizar.Dto = null;

    get carregando() {
        return !this.pedido;
    }

    async created() {
        this.pedido = await pedidoService.obterParaVisualizar({
            pedidoId: this.pedidoId,
        });

        if (this.pedido != null) {
            this.pedido.data = obterDiaMesAnoFormatado(this.pedido.data);
            this.pedido.situacaoPagamentoAtualizadaEm = obterDiaMesAnoFormatado(
                this.pedido.situacaoPagamentoAtualizadaEm
            );
        }
    }

    async voltar() {
        await routerService.goTo('pedido-listar');
    }
}
